module.exports = __webpack_public_path__ + "img/bingo_ball-29.05ca239f.png";